//@flow
import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import BusinessUnitSelector from 'common/components/businessUnit/BusinessUnitSelector';
import HeaderWithLogout from './HeaderWithLogout';
import theme from './HeaderWithLogoutAndBU.scss';

export const headerWithLogoutAndBUFactory = ({ Left, Right }) => {
    class HeaderWithLogoutAndBU extends Component {
        render() {
            const {
                theme,
                hideBUSelector,
                children,
                className,
                showUiSwitchIcon,
                onRevert,
                onUpgrade,
                product,
                ...others
            } = this.props;
            return (
                <HeaderWithLogout
                    className={className}
                    showUiSwitchIcon={showUiSwitchIcon}
                    onRevert={onRevert}
                    onUpgrade={onUpgrade}
                    product={product}
                >
                    <>
                        {!hideBUSelector ? (
                            <BusinessUnitSelector {...others} theme={theme} />
                        ) : null}
                        {Left && <Left {...others} theme={theme} />}
                        {Right && <Right {...others} theme={theme} />}
                        {children}
                    </>
                </HeaderWithLogout>
            );
        }
    }
    return themr('HeaderWithLogoutAndBU', theme)(HeaderWithLogoutAndBU);
};

const HeaderWithLogoutAndBU = headerWithLogoutAndBUFactory({});
export { HeaderWithLogoutAndBU };
